import { useLanguage } from '@/hooks/useLanguage';

/**
 * Rendered when the URL contains a tenant slug that doesn't exist.
 * Intentionally bare — no branding, no styling beyond what a plain
 * web server's default 404 looks like. The point is to communicate
 * "this URL doesn't exist" without giving the visitor any
 * platform-specific UI to interact with.
 */

export function TenantNotFound() {
  const { t } = useLanguage();
  return (
    <div style={{ fontFamily: 'serif', padding: '1em', background: '#fff', color: '#000', minHeight: '100vh' }}>
      <h1>{t('common.notFound')}</h1>
      <p>{t('common.urlNotFound')}</p>
    </div>
  );
}
